import { getPH } from './phClient'

export const buildTrack = () => {
  const ph = getPH()

  const cap = (name: string, props?: Record<string, any>) =>
    ph?.capture(name, props)

  return {
    event: (name: string, props?: Record<string, any>) => cap(name, props),

    journey: {
      viewed: (p: any) => cap('journey_viewed', p),
      blocked: (p: any) => cap('journey_blocked', p)
    },

    stage: {},

    level: {
      viewed: (p: any) => cap('level_viewed', p),
      started: (p: any) => cap('level_started', p),
      continue: (p: any) => cap('level_continue', p),
      outOfTime: (p: any) => cap('level_out_of_time', p),
      outOfHearts: (p: any) => cap('level_out_of_hearts', p),
      leave: (p: any) => cap('level_leave', p),
      completed: (p: any) => cap('level_completed', p),

      blocked: (p: any) => cap('level_blocked', p)
    },

    challenge: {},

    mission: {
      viewed: (p: any) => cap('mission_viewed', p),
      started: (p: any) => cap('mission_started', p),
      completed: (p: any) => cap('mission_completed', p),
      failed: (p: any) => cap('mission_failed', p)
    },

    document: {
      viewed: (p: any) => cap('document_viewed', p),
      downloaded: (p: any) => cap('document_downloaded', p),
      submitted: (p: any) => cap('document_submitted', p),
      signed: (p: any) => cap('document_signed', p),
      verified: (p: any) => cap('document_verified', p)
    }
  }
}
